import { generateCombinedConfigHash as generateCombinedConfigHashBase } from './hash';

export const GQL_OPERATION_NAME = 'searchCombinedConfig';

export const getSearchConfigQuery = () => `
query ${GQL_OPERATION_NAME}($cloudId: ID!) {
  search {
      configuration(cloudId: $cloudId) {
        firstPartyProducts {
          name
        }
        thirdPartyProducts {
          name
          outboundAuthUrl
          isUserOAuthed
          providerId
          integrationARI
          workspaceName
          workspaceUrl
          datasourceId
          connectionId
          connectorSyncType
          isImpersonationAuthEnabled
          connectorCreatedAt
          lightIcon
          entityTypes
          environmentType
        }
        intercomHmac
        siteMetadata {
          isRovoEnabled
          isJiraIssueIndexed
          applicationMode
          siteName
          orgId
          productEdition
          productInfo {
            name
            dataRegion
          }
        }
    }
  }
}`;

export const generateCombinedConfigHash = (userId: string, cloudId: string): number =>
	generateCombinedConfigHashBase(userId, cloudId);
